import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

const controllerUrl = `${apiUrl}sharing/account`;

export const requestNoPagination = (filters) =>
  axios.post(`${controllerUrl}/list`, {
    criteria: filters
  });

export const requestCreate = (data) => axios.post(`${controllerUrl}`, data);

export const requestUpdate = (id, data) => axios.put(`${controllerUrl}/${id}`, data);

export const requestDelete = (id) => axios.delete(`${controllerUrl}/${id}`);



// WEBPACK FOOTER //
// ./src/actions/sharing/requests.js